import React from 'react'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import AlertBox from 'components/AlertBox/AlertBox'
import InfoList from 'components/InfoList/InfoList'

import styles from '../Dialog.module.sass'
import { mapTransferOpinionDetails } from 'controllers/TaskManager/TaskSubControllers/TaskDetailsControllers/detailsUtils'

export const TransferClinicalApprovalTaskInfo = (props) => {
	const { isAdministrative, requisition, requestProcess, data } = props
	const { i18n } = useGlobal()

	const message = i18n`The destination provider was changed from ${
		requestProcess?.proposedEstablishment?.name || i18n`Not defined`
	} to ${requisition?.establishment?.name || i18n`Not defined`}.`

	const warningMessage = [
		{
			title: i18n`Warning`,
			text: message,
		},
	]

	const details = mapTransferOpinionDetails(requisition, data, i18n)

	return (
		<>
			{requestProcess &&
				requestProcess?.proposedEstablishment?.id !==
					requisition?.establishment?.id && (
					<AlertBox
						className={styles['alert-box']}
						type='warning'
						items={warningMessage}
					/>
				)}

			{isAdministrative && (
				<InfoList
					items={[
						{
							title: i18n`Medical observation`,
							text: requisition?.clinicalObservation || '-',
							icon: 'observation',
						},
					]}
				/>
			)}

			<InfoList items={details} />
		</>
	)
}
